var render, staticRenderFns
import script from "./stepUiMixin.vue?vue&type=script&lang=js&"
export * from "./stepUiMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15feb99a')) {
      api.createRecord('15feb99a', component.options)
    } else {
      api.reload('15feb99a', component.options)
    }
    
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/stepUiMixin.vue"
export default component.exports